import { OctIconButton } from "@oceantech/oceantech-ui";
import { MouseEvent } from "react";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { CustomColumn } from "../../component/table/table-custom/tableCustomeModel";

export const SIGNATURE_COLUMNS: CustomColumn<any>[] = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-50px" title="Thao tác" />
		),
		accessor: "action",
		Cell: ({ row: { original }, tableOptions: { onActionButtonClick } }: any) => {
			return (
				<TableCustomCell
					className="min-w-50px"
					data={
						<div className="d-flex justify-content-center">
							<OctIconButton
								variant="edit"
								title="Xem phiếu ký"
								onClick={(e: MouseEvent<HTMLButtonElement>) => {
									e.stopPropagation();
									onActionButtonClick(original, "viewPatient");
								}}
							>
								<i className="bi bi-file-earmark-text text-navy"></i>
							</OctIconButton>
						</div>
					}
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-50px" title="STT" />
		),
		accessor: "order",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-50px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-200px" title="Họ và tên" />
		),
		accessor: "personName",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-200px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Mã bệnh nhân"
			/>
		),
		accessor: "code",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-125px" title="Tên phiếu" />
		),
		accessor: "name",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-100px" title="Người tạo" />
		),
		accessor: "createdBy",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-125px" title="Ngày tạo" />
		),
		accessor: "createdDate",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-125px"
				title="Loại hồ sơ"
			/>
		),
		accessor: "brief",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-100px" title="Số chữ ký" />
		),
		accessor: "signNum",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-125px" title="Người ký" />
		),
		accessor: "signBy",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-125px"
				title="Thời gian ký"
			/>
		),
		accessor: "signDate",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Trạng thái"
			/>
		),
		accessor: "status",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
];

export const SIGNATURE_FORM_COLUMNS: CustomColumn<any>[] = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-50px" title="STT" />
		),
		accessor: "order",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-50px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-200px" title="Tên phiếu" />
		),
		accessor: "name",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-200px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-125px" title="Số chữ ký" />
		),
		accessor: "signNum",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-200px"
				title="Tên bệnh nhân"
			/>
		),
		accessor: "patientName",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-200px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Trạng thái"
			/>
		),
		accessor: "status",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
];
